<template>
  <SelectionLinkMenu
    :title="$t('contextual-menu.link-to-task')"
    :emptyMessage="$t('contextual-menu.no-tasks')"
    :items="filteredItems"
    :horizontalPosition="horizontalPosition"
    :verticalPosition="verticalPosition"
    :searchAllowed="searchAllowed"
    :isItemConnected="checkIsConnected"
    @select-item="onTaskClick"
    @search="filterTaskItems"
    @size-changed="$emit('sizeChanged', $event)"
    @close="$emit('close', true)"
    @mouseenter.native="$emit('mouseenter')"
  >
    <template #prepend-items>
      <div class="task-link-menu__create-action" @click="$emit('task-create')">
        <span class="task-link-menu__create-action-left">
          <span class="task-link-menu__create-action-icon">+</span>
          <span>{{ $t('contextual-menu.create-task') }}</span>
        </span>
        <!--        <span class="task-link-menu__create-action-shortcut">{{ $t('contextual-menu.shortcut') }}</span>-->
      </div>
    </template>
    <template #item="{ item }">{{ item.label }}</template>
  </SelectionLinkMenu>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import AnnotationHighlightMixin from '@/mixins/annotation-highlight-mixin';
import SelectionLinkMenu from '@/components/pdf-viewer/SelectionLinkMenu.vue';

export default {
  name: 'TaskLinkMenu',
  components: { SelectionLinkMenu },
  mixins: [AnnotationHighlightMixin],
  props: {
    searchAllowed: {
      type: Boolean,
      default: false,
    },
    horizontalPosition: {
      type: Object,
    },
    verticalPosition: {
      type: Object,
    },
    opportunityId: String,
  },
  data() {
    return {
      filteredItems: [],
    };
  },
  computed: {
    ...mapGetters('tasks', ['tasks']),
    ...mapGetters('opportunityDocuments', ['opportunityDocument']),
    sortedTasks() {
      return this.tasks
        .slice()
        .sort((a, b) => a.title.localeCompare(b.title))
        .map((task) => ({
          id: task.id,
          label: task.title,
          _raw: task,
        }));
    },
  },
  methods: {
    filterTaskItems(query) {
      this.filteredItems = this.tasks
        .filter((task) => task.title.toLowerCase().includes(query.toLowerCase()))
        .sort((a, b) => a.title.localeCompare(b.title))
        .map((task) => ({
          id: task.id,
          label: task.title,
          _raw: task,
        }));
    },
    checkIsConnected(item) {
      if (!this.selectedAnnotation) return false;
      return item._raw.citations.some((citation) => citation.textAnnotationId === this.selectedAnnotation.id);
    },
    async onTaskClick(item) {
      if (!this.selectedAnnotation) {
        await this.highlightAnnotationAndReturnSelected();
      }

      if (!this.selectedAnnotation) return;

      if (this.checkIsConnected(item)) {
        this.$emit('close', true);
        return;
      }

      this.$emit('link-selection-to-task', item._raw);
      this.$emit('close', true);
    },
  },
  watch: {
    tasks: {
      immediate: true,
      handler() {
        this.filteredItems = this.sortedTasks;
      },
    },
  },
};
</script>

<style lang="scss">
.task-link-menu {
  &__create-action {
    cursor: pointer;
    padding: 8px;
    border-radius: $border-radius-small;
    display: flex;
    justify-content: space-between;
    align-items: center;
    min-height: 36px;
    flex-shrink: 0;
    height: auto;
    transition: all 200ms ease;
    border-bottom: 1px solid $color-border;
    margin-bottom: 4px;

    &:hover {
      background-color: $color-hover;
    }

    &-left {
      display: flex;
      align-items: center;
      gap: 8px;
      color: $color-accent;
      font-weight: 700;
    }

    &-icon {
      font-size: 18px;
      line-height: 1;
    }

    &-shortcut {
      font-size: 12px;
      color: $color-neutral;
      background: $color-neutral-pale;
      padding: 2px 8px;
      border-radius: $border-radius-small;
    }
  }
}
</style>
